import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Calendar, MapPin, Users, Clock, ArrowLeft, CheckCircle, FileText, Download, User, Mail, Phone, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { useToast } from '../components/ui/Toast';
import { Avatar } from '../components/ui/Avatar';
export function MeetingDetail() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const {
    showToast
  } = useToast();
  const [isConfirmed, setIsConfirmed] = useState(false);
  // Mock meeting data
  const meeting = {
    id: 6,
    category: 'meeting',
    title: 'Rapat Komite Pusat - Q1 2025',
    description: 'Rapat komite pusat untuk evaluasi Q4 2024 dan perencanaan Q1 2025. Agenda meliputi review program kerja, pembahasan anggaran, dan strategi pengembangan organisasi.',
    date: '30 Januari 2025',
    time: '10:00 - 15:00 WIB',
    location: 'ATIOS HQ Jakarta, Ruang Rapat Utama Lt. 3',
    type: 'offline',
    organizer: {
      name: 'Komite Pusat ATIOS',
      email: 'komite@atios.id',
      phone: '+62812345678'
    },
    status: 'invitation-only',
    attendees: [{
      name: 'Budi Santoso',
      role: 'Ketua Umum',
      status: 'confirmed',
      avatar: 'BS'
    }, {
      name: 'Siti Nurhaliza',
      role: 'Sekretaris',
      status: 'confirmed',
      avatar: 'SN'
    }, {
      name: 'Ahmad Wijaya',
      role: 'Bendahara',
      status: 'confirmed',
      avatar: 'AW'
    }, {
      name: 'Dewi Lestari',
      role: 'Koordinator Chapter',
      status: 'pending',
      avatar: 'DL'
    }, {
      name: 'Made Suryawan',
      role: 'Koordinator Event',
      status: 'confirmed',
      avatar: 'MS'
    }, {
      name: 'Rina Situmorang',
      role: 'Koordinator Keanggotaan',
      status: 'confirmed',
      avatar: 'RS'
    }, {
      name: 'John Doe',
      role: 'Anggota Komite',
      status: 'pending',
      avatar: 'JD'
    }],
    agenda: [{
      time: '10:00 - 10:15',
      topic: 'Pembukaan dan Absensi',
      presenter: 'Ketua Umum'
    }, {
      time: '10:15 - 11:00',
      topic: 'Evaluasi Program Kerja Q4 2024',
      presenter: 'Sekretaris'
    }, {
      time: '11:00 - 11:45',
      topic: 'Laporan Keuangan Q4 2024',
      presenter: 'Bendahara'
    }, {
      time: '11:45 - 12:00',
      topic: 'Break',
      presenter: '-'
    }, {
      time: '12:00 - 13:00',
      topic: 'Perencanaan Program Kerja Q1 2025',
      presenter: 'Koordinator Chapter'
    }, {
      time: '13:00 - 14:00',
      topic: 'Lunch Break',
      presenter: '-'
    }, {
      time: '14:00 - 14:45',
      topic: 'Pembahasan Anggaran Q1 2025',
      presenter: 'Bendahara'
    }, {
      time: '14:45 - 15:00',
      topic: 'Penutupan dan Kesimpulan',
      presenter: 'Ketua Umum'
    }],
    documents: [{
      name: 'Undangan Rapat Resmi.pdf',
      size: '245 KB',
      type: 'pdf'
    }, {
      name: 'Laporan Keuangan Q4 2024.xlsx',
      size: '1.2 MB',
      type: 'excel'
    }, {
      name: 'Draft Program Kerja Q1 2025.docx',
      size: '856 KB',
      type: 'word'
    }, {
      name: 'Notulen Rapat Sebelumnya.pdf',
      size: '512 KB',
      type: 'pdf'
    }],
    notes: ['Peserta diharapkan hadir tepat waktu', 'Membawa laptop untuk presentasi', 'Dress code: Business casual', 'Konfirmasi kehadiran paling lambat 2 hari sebelum rapat']
  };
  const handleConfirmAttendance = () => {
    setIsConfirmed(true);
    showToast('success', 'Kehadiran Dikonfirmasi!', 'Terima kasih telah mengkonfirmasi kehadiran Anda.');
  };
  const handleDownloadDocument = (docName: string) => {
    showToast('success', 'Dokumen Diunduh', `${docName} sedang diunduh`);
  };
  return <div className="min-h-screen bg-white" data-id="element-3767">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8" data-id="element-3768">
        {/* Back Button */}
        <Button variant="ghost" onClick={() => navigate('/events')} data-id="element-3769">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-3770" />
          Kembali ke Events
        </Button>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-3771">
          {/* Main Content */}
          <div className="lg:col-span-2 space-y-6" data-id="element-3772">
            {/* Header */}
            <Card data-id="element-3773">
              <CardHeader data-id="element-3774">
                <div className="flex items-start justify-between mb-4" data-id="element-3775">
                  <Badge variant="warning" data-id="element-3776">RAPAT</Badge>
                  <Badge variant="default" data-id="element-3777">KHUSUS UNDANGAN</Badge>
                </div>
                <CardTitle className="text-2xl mb-2 text-text-primary" data-id="element-3778">
                  {meeting.title}
                </CardTitle>
                <p className="text-text-secondary" data-id="element-3779">{meeting.description}</p>
              </CardHeader>
              <CardContent className="space-y-6" data-id="element-3780">
                {/* Meeting Info */}
                <div className="grid grid-cols-2 gap-4" data-id="element-3781">
                  <div className="flex items-center gap-3" data-id="element-3782">
                    <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center" data-id="element-3783">
                      <Calendar className="h-5 w-5 text-primary" data-id="element-3784" />
                    </div>
                    <div data-id="element-3785">
                      <p className="text-xs text-text-muted" data-id="element-3786">Tanggal</p>
                      <p className="text-sm font-medium text-text-primary" data-id="element-3787">
                        {meeting.date}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-3788">
                    <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center" data-id="element-3789">
                      <Clock className="h-5 w-5 text-primary" data-id="element-3790" />
                    </div>
                    <div data-id="element-3791">
                      <p className="text-xs text-text-muted" data-id="element-3792">Waktu</p>
                      <p className="text-sm font-medium text-text-primary" data-id="element-3793">
                        {meeting.time}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 col-span-2" data-id="element-3794">
                    <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center" data-id="element-3795">
                      <MapPin className="h-5 w-5 text-primary" data-id="element-3796" />
                    </div>
                    <div data-id="element-3797">
                      <p className="text-xs text-text-muted" data-id="element-3798">Lokasi</p>
                      <p className="text-sm font-medium text-text-primary" data-id="element-3799">
                        {meeting.location}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Organizer */}
                <div className="pt-6 border-t border-border" data-id="element-3800">
                  <h3 className="text-lg font-bold text-text-primary mb-4" data-id="element-3801">
                    Penyelenggara
                  </h3>
                  <div className="space-y-2" data-id="element-3802">
                    <div className="flex items-center gap-2 text-sm" data-id="element-3803">
                      <User className="w-4 h-4 text-primary" data-id="element-3804" />
                      <span className="text-text-primary font-medium" data-id="element-3805">
                        {meeting.organizer.name}
                      </span>
                    </div>
                    <div className="flex items-center gap-2 text-sm" data-id="element-3806">
                      <Mail className="w-4 h-4 text-primary" data-id="element-3807" />
                      <span className="text-text-secondary" data-id="element-3808">
                        {meeting.organizer.email}
                      </span>
                    </div>
                    <div className="flex items-center gap-2 text-sm" data-id="element-3809">
                      <Phone className="w-4 h-4 text-primary" data-id="element-3810" />
                      <span className="text-text-secondary" data-id="element-3811">
                        {meeting.organizer.phone}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Agenda */}
                <div className="pt-6 border-t border-border" data-id="element-3812">
                  <h3 className="text-lg font-bold text-text-primary mb-4" data-id="element-3813">
                    Agenda Rapat
                  </h3>
                  <div className="space-y-3" data-id="element-3814">
                    {meeting.agenda.map((item, i) => <div key={i} className="flex gap-4 p-3 rounded bg-background-secondary hover:bg-border/30 transition-colors" data-id="element-3815">
                        <span className="text-primary font-medium min-w-[140px] text-sm" data-id="element-3816">
                          {item.time}
                        </span>
                        <div className="flex-1" data-id="element-3817">
                          <p className="text-text-primary font-medium text-sm" data-id="element-3818">
                            {item.topic}
                          </p>
                          {item.presenter !== '-' && <p className="text-text-muted text-xs mt-1" data-id="element-3819">
                              Presenter: {item.presenter}
                            </p>}
                        </div>
                      </div>)}
                  </div>
                </div>

                {/* Documents */}
                <div className="pt-6 border-t border-border" data-id="element-3820">
                  <h3 className="text-lg font-bold text-text-primary mb-4" data-id="element-3821">
                    Dokumen Rapat
                  </h3>
                  <div className="space-y-3" data-id="element-3822">
                    {meeting.documents.map((doc, i) => <div key={i} className="flex items-center justify-between p-4 rounded border-2 border-dashed border-accent hover:border-primary transition-colors" data-id="element-3823">
                        <div className="flex items-center gap-3" data-id="element-3824">
                          <div className="h-10 w-10 rounded bg-primary/10 flex items-center justify-center" data-id="element-3825">
                            <FileText className="h-5 w-5 text-primary" data-id="element-3826" />
                          </div>
                          <div data-id="element-3827">
                            <p className="text-sm font-medium text-text-primary" data-id="element-3828">
                              {doc.name}
                            </p>
                            <p className="text-xs text-text-muted" data-id="element-3829">
                              {doc.size}
                            </p>
                          </div>
                        </div>
                        <Button variant="outline" size="sm" onClick={() => handleDownloadDocument(doc.name)} data-id="element-3830">
                          <Download className="w-4 h-4 mr-2" data-id="element-3831" />
                          Download
                        </Button>
                      </div>)}
                  </div>
                </div>

                {/* Notes */}
                <div className="pt-6 border-t border-border" data-id="element-3832">
                  <h3 className="text-lg font-bold text-text-primary mb-4" data-id="element-3833">
                    Catatan Penting
                  </h3>
                  <div className="space-y-2" data-id="element-3834">
                    {meeting.notes.map((note, i) => <div key={i} className="flex items-start gap-2" data-id="element-3835">
                        <AlertCircle className="w-4 h-4 text-warning mt-0.5 flex-shrink-0" data-id="element-3836" />
                        <p className="text-sm text-text-secondary" data-id="element-3837">{note}</p>
                      </div>)}
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Sidebar */}
          <div className="space-y-6" data-id="element-3838">
            {/* Confirmation Card */}
            <Card className="sticky top-8" data-id="element-3839">
              <CardHeader data-id="element-3840">
                <CardTitle className="text-lg" data-id="element-3841">Konfirmasi Kehadiran</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4" data-id="element-3842">
                {!isConfirmed ? <>
                    <div className="flex items-center gap-2 text-sm text-text-secondary bg-background-secondary p-3 rounded" data-id="element-3843">
                      <AlertCircle className="w-4 h-4 text-warning" data-id="element-3844" />
                      <span data-id="element-3845">
                        Mohon konfirmasi kehadiran Anda paling lambat 2 hari
                        sebelum rapat
                      </span>
                    </div>

                    <Button className="w-full" size="lg" onClick={handleConfirmAttendance} data-id="element-3846">
                      Konfirmasi Kehadiran
                    </Button>

                    <Button className="w-full" variant="outline" data-id="element-3847">
                      Tidak Bisa Hadir
                    </Button>
                  </> : <div className="space-y-4" data-id="element-3848">
                    <div className="flex items-center gap-3 text-success bg-success/10 p-4 rounded border-2 border-success/20" data-id="element-3849">
                      <CheckCircle className="w-6 h-6" data-id="element-3850" />
                      <div data-id="element-3851">
                        <p className="font-semibold text-text-primary" data-id="element-3852">
                          Kehadiran Dikonfirmasi!
                        </p>
                        <p className="text-xs text-text-secondary" data-id="element-3853">
                          Kami tunggu kehadiran Anda
                        </p>
                      </div>
                    </div>

                    <Button className="w-full" variant="outline" data-id="element-3854">
                      Ubah Status Kehadiran
                    </Button>
                  </div>}
              </CardContent>
            </Card>

            {/* Attendees Card */}
            <Card data-id="element-3855">
              <CardHeader data-id="element-3856">
                <CardTitle className="text-base" data-id="element-3857">
                  Daftar Undangan ({meeting.attendees.length})
                </CardTitle>
              </CardHeader>
              <CardContent data-id="element-3858">
                <div className="space-y-3" data-id="element-3859">
                  {meeting.attendees.map((attendee, i) => <div key={i} className="flex items-center justify-between p-2 rounded hover:bg-background-secondary transition-colors" data-id="element-3860">
                      <div className="flex items-center gap-3" data-id="element-3861">
                        <div className="h-10 w-10 rounded-full bg-primary/10 border-2 border-primary flex items-center justify-center text-primary font-medium text-sm" data-id="element-3862">
                          {attendee.avatar}
                        </div>
                        <div data-id="element-3863">
                          <p className="text-sm font-medium text-text-primary" data-id="element-3864">
                            {attendee.name}
                          </p>
                          <p className="text-xs text-text-muted" data-id="element-3865">
                            {attendee.role}
                          </p>
                        </div>
                      </div>
                      {attendee.status === 'confirmed' ? <CheckCircle className="w-4 h-4 text-success" data-id="element-3866" /> : <Clock className="w-4 h-4 text-warning" data-id="element-3867" />}
                    </div>)}
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>;
}